module.exports = __webpack_public_path__ + "img/item7.d9e9381d.png";